import Link from "next/link";
import { inter } from "../../../shared/fonts/inter";
import "../../../shared/animations/animate.css";
import AnimatedBody from "../../../shared/animations/AnimatedBody";
import AnimatedTitle from "../../../shared/animations/AnimatedTitle";
import AnimatedWords from "../../../shared/animations/AnimatedWords";
import { motion } from "motion/react";
import ContactBackground from "../background/ContactBackground";
import React from "react";
import { contactText } from "../../../../../data";
import ContactDialog from "../contact-form/ContactDialog";
import posthog from "posthog-js";

const Contact = () => {
  return (
    <motion.section
      className="relative z-10 flex h-[85vh] w-full items-center justify-center overflow-hidden py-16 md:h-[80vh] md:py-20 lg:h-[90vh] lg:pb-28 lg:pt-0"
      id="contact"
      initial="initial"
      animate="animate"
    >
      <ContactBackground />
      <div className="mx-auto flex w-[90%] flex-col items-center justify-center pt-10 md:pt-0">
        <div
          className={`flex flex-col items-center justify-center ${inter.className} relative w-full text-center lg:max-w-[1440px]`}
        >
          <AnimatedWords
            title={contactText.mail.title}
            style={
              "font-extrabold uppercase leading-[0.9em] text-[#e4ded7] text-[70px] sm:text-[100px] md:text-[150px] lg:text-[200px] xl:text-[250px]"
            }
          />
        </div>

        <div className="z-10  mt-2 flex w-full flex-col items-center justify-center gap-8 sm:mt-5 sm:flex-row sm:items-end sm:gap-16 md:mt-10 md:items-start md:justify-between lg:mt-12 lg:max-w-[1440px]">
          <div className="ml-2 flex w-[350px] max-w-[90%] flex-col items-center justify-center text-left text-[14px] font-semibold uppercase  text-[#e4ded7]  sm:ml-0 sm:text-[14px] md:justify-start md:text-[16px] lg:w-[420px] lg:text-[16px]">
            <AnimatedBody
              text={contactText.mail.text1}
              className={
                "-mb-1 inline-block overflow-hidden pt-1 text-start sm:-mb-2 md:-mb-3 lg:-mb-4"
              }
            />
            <ContactDialog
              triggerComponent={
                <div onClick={() => posthog.capture("contact_form_open")}>
                  <AnimatedBody text={contactText.mail.text2} />
                </div>
              }
              className="mt-1 w-full flex-1 text-start uppercase underline underline-offset-2 hover:no-underline sm:mt-2 md:mt-3 lg:mt-4"
            />
          </div>

          <div className="flex gap-10 text-[16px] font-bold text-[#e4ded7]  sm:gap-14 sm:text-[20px] md:gap-10 md:text-[24px] lg:gap-20 lg:text-[28px]">
            <ContactLink platform="GITHUB" href={contactText.social.github} />
            <ContactLink platform="DISCORD" href={contactText.social.discord} />
            {/* <ContactLink platform="LINKEDIN" href={contactText.social.linkedin} /> */}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

const ContactLink = ({
  href,
  platform,
}: {
  href: string;
  platform: string;
}) => {
  return (
    <Link
      href={href}
      aria-label={`View my ${platform.toLowerCase()} profile`}
      onClick={() => {
        posthog.capture("contact_link", { platform: platform });
      }}
    >
      <AnimatedTitle
        text={platform.toUpperCase()}
        className={
          "text-[16px] font-bold text-[#e4ded7] sm:text-[20px] md:text-[16px] lg:text-[28px]"
        }
        wordSpace={"mr-[0.25em]"}
        charSpace={"mr-[0.01em]"}
      />
    </Link>
  );
};

export default Contact;
